module.exports = __webpack_public_path__ + "img/LogoBaiturrahmanMobile.f14de0ce.png";